import { error, warn, info, debug } from '@eika-infrastruktur/log';

type LogDomain = 'signing' | 'sitecore' | 'query' | 'error-bundary' | 'default' | 'wallet';

const customLog =
    (fun: typeof error) => (domain: LogDomain, message: string, source: string, rest?: Record<string, any>) => {
        fun({ app: 'kredittkort-betjening-web', domain, message, source, ...rest });
    };

export const Logger = {
    info: customLog(info),
    warn: customLog(warn),
    error: customLog(error),
    debug: customLog(debug),
};
